import { Avatar, Box, Typography } from "@mui/material";
import { Communication } from "../types/types";
import { Premium, Primary } from "../../../core-components/theme/color-palette/colors";
import DrPaani from "../../../core-components/assets/icons/DrPaani";
import { getInitials } from "../../../utilities/string.utils";


export function getAvatar(communication: Communication): { avatar: React.ReactNode; avatarBoxSx: any; borderWrapper: React.ReactNode } {

  const premiumGradient = `conic-gradient(
    ${Premium[700]},
    ${Premium[500]},
    ${Premium[200]},
    ${Premium[700]},
    ${Premium[900]},
    ${Premium[700]},
    ${Premium[500]},
    ${Premium[200]},
    ${Premium[700]}
  )`;
  
  
    let avatar: React.ReactNode;
    let avatarBoxSx: any = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 48,
      height: 48,
      borderRadius: '50%',
      bgcolor: '#F2F7FB',
      border: '1px solid #E3E8EF',
      flexShrink: 0,
      overflow: 'hidden',
      position: 'relative',
    };
    let borderWrapper: React.ReactNode = null;
    if (communication.senderType ==='DOCTOR_PAANI') {
      borderWrapper = (
        <Box
          sx={{
            position: 'absolute',
            top: -1,
            left: -1,
            width: 51,
            height: 51,
            borderRadius: '50%',
            zIndex: 0,
            background: premiumGradient,
            animation: 'rotate-border 2s linear infinite',
          }}
        />
      );
      avatarBoxSx = {
        ...avatarBoxSx,
        bgcolor: 'transparent',
        border: 'none',
      };
      avatar = <Box sx={{ width: "100%", height: "100%", borderRadius: "50%", bgcolor: 'white',position:'absolute', top:'50%', left:'50%', transform:'translate(-48%, -48%)' }}><DrPaani width={44} height={48} /></Box>;
    } else if (communication.profilePictureURL) {
      avatarBoxSx = {
        ...avatarBoxSx,
        border: `1px solid ${Primary[700]}`,
        bgcolor: '#fff',
        p: 0,
      };
      avatar = <Avatar src={communication.profilePictureURL} sx={{ width: "100%", height: "100%",}} />;
    } else if (communication.messageHeader) {
      avatarBoxSx = {
        ...avatarBoxSx,
        bgcolor: Primary[900],
        border: `1px solid ${Primary[700]}`,
      };
      avatar = <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 18 }}>{getInitials(communication.messageHeader, 2)}</Typography>;
    } else {
      avatar = <Avatar sx={{ width: 40, height: 40 }}>?</Avatar>;
    }
    return { avatar, avatarBoxSx, borderWrapper };
  }